import { AlertNotification } from '@uk-source-web/alert-notification';
import { Paragraph } from '@vfmfe/foundations';
import { ReactNode } from 'react';
import useNotifications from '../../hooks/useNotifications';
import { NotificationContainer, NotificationsContainer } from './styles.root';

const NotificationsProvider = ({ children }: { children: ReactNode }) => {
    const { notifications, removeNotification } = useNotifications();

    return (
        <>
            {!!notifications.length && (
                <NotificationsContainer>
                    {notifications.map((notification, index) => (
                        <NotificationContainer key={index}>
                            <AlertNotification
                                state={notification.severity === 'warning' ? 'warn' : notification.severity}
                                closeButton={{
                                    srText: 'close notification',
                                    onClick: () => {
                                        removeNotification(index);
                                    }
                                }}
                            >
                                <Paragraph>{notification.message}</Paragraph>
                            </AlertNotification>
                        </NotificationContainer>
                    ))}
                </NotificationsContainer>
            )}
            {children}
        </>
    );
};

export default NotificationsProvider;
